export default __webpack_public_path__ + "static/msfLogo-87640c87e0cb6de425113aa3cf1b1e9a.png";